import React, { Component } from 'react';
import './Footer.scss';
import github from '../../assets/github-logo.svg';
import vk from '../../assets/vk-logo.svg';
import movieDb from '../../assets/movieDB.svg';
import telegram from '../../assets/telegram.svg';
import { Link } from 'react-router-dom';
import Particles from 'react-particles-js';

const footerBackgroundUrl =
  'https://images.unsplash.com/photo-1539721972319-f0e80a00d424?ixlib=rb-1.2.1&ixid' +
  '=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1950&q=80';

class Footer extends Component {
  footerRef = React.createRef();

  componentDidMount() {
    this.setBackground();
  }

  setBackground = () => {
    const img = new Image();
    img.src = footerBackgroundUrl;
    img.onload = () => {
      this.footerRef.current.style.backgroundImage = `url('${img.src}')`;
    };
  };

  render() {
    return (
      <footer className="footer" ref={this.footerRef}>
        <Particles
          canvasClassName="canvas"
          params={{
            particles: {
              number: {
                value: 600,
                density: { enable: true, value_area: 400.59929654763494 }
              },
              color: { value: '#ffffff' },
              shape: {
                type: 'circle',
                stroke: { width: 0, color: '#000000' },
                polygon: { nb_sides: 3 },
                image: { src: 'img/github.svg', width: 100, height: 100 }
              },
              opacity: {
                value: 1,
                random: true,
                anim: { enable: true, speed: 1, opacity_min: 0, sync: false }
              },
              size: {
                value: 3,
                random: true,
                anim: { enable: true, speed: 0, size_min: 0.3, sync: true }
              },
              line_linked: {
                enable: false,
                distance: 150,
                color: '#ffffff',
                opacity: 0.4,
                width: 1
              },
              move: {
                enable: true,
                speed: 1,
                direction: 'none',
                random: true,
                straight: false,
                out_mode: 'out',
                bounce: false,
                attract: { enable: false, rotateX: 600, rotateY: 600 }
              }
            },
            interactivity: {
              detect_on: 'canvas',
              events: {
                onhover: { enable: true, mode: 'repulse' },
                onclick: { enable: false, mode: 'repulse' },
                resize: true
              },
              modes: {
                grab: {
                  distance: 267.8027997565431,
                  line_linked: { opacity: 1 }
                },
                bubble: {
                  distance: 250,
                  size: 0,
                  duration: 2,
                  opacity: 0,
                  speed: 3
                },
                repulse: { distance: 40.57618178129441, duration: 0.4 },
                push: { particles_nb: 4 },
                remove: { particles_nb: 2 }
              }
            },
            retina_detect: true
          }}
        />
        <section className="footer-info">
          <h2 className="footer-info-title">The Galaxy of Movies</h2>
          <ul className="footer-info-list">
            <li className="footer-info-li">
              <Link to="/" className="footer-info-link">
                Home
              </Link>
            </li>
            <li className="footer-info-li">
              <Link to="/login" className="footer-info-link">
                Login
              </Link>
            </li>
            <li className="footer-info-li">
              <Link to="/search" className="footer-info-link">
                Search
              </Link>
            </li>
          </ul>
          <p className="footer-info-contact">maximrodionovj@gmail.com</p>
          <p className="footer-info-copyright">Copyright ©2019</p>
        </section>
        <section className="footer-social">
          <div className="footer-social-source">
            <a href="https://www.themoviedb.org/">
              <img src={movieDb} alt="MovieDb" />
            </a>
          </div>
          <ul className="footer-social__list">
            <li className="footer-social__li">
              <a
                href="https://github.com/vrnnofate/simple-react-movie-app"
                className="footer-social__link">
                <img className="footer-social__img" src={github} alt="github" />
              </a>
            </li>
            <li className="footer-social__li">
              <a
                href="https://vk.com/stillnofate"
                className="footer-social__link">
                <img className="footer-social__img" src={vk} alt="vk" />
              </a>
            </li>
            <li className="footer-social__li">
              <a
                href="https://t.me/MaximRodionovJ"
                className="footer-social__link">
                <img
                  className="footer-social__img"
                  src={telegram}
                  alt="telegram"
                />
              </a>
            </li>
          </ul>
        </section>
      </footer>
    );
  }
}

export default Footer;
